const API_URL = 'https://api.demo-token.debaly.com';
const DEBALY_TOKEN = 'REPLACE_YOUR_LICENSE';

export {API_URL, DEBALY_TOKEN}
